import React from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
import type { Testimonial } from '../data/testimonials';
type TestimonialsProps = {
  testimonials: Testimonial[];
  eyebrow?: string;
  title?: string;
  subtitle?: string;
  background?: 'white' | 'blush';
};
export function Testimonials({
  testimonials,
  eyebrow = 'Colleague to colleague',
  title = 'What counselors are saying',
  subtitle,
  background = 'white'
}: TestimonialsProps) {
  const bg = background === 'white' ? 'bg-white' : 'bg-rose-soft';
  return <section aria-label={title} className={`w-full text-navy ${bg}`} data-id="element-307" data-mp="31z3ayp60lf7v">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:py-20" data-id="element-308" data-mp="2x09v4q399c4j">
        <div className="text-center" data-id="element-309" data-mp="2x2w50wdmc3px">
          <p className="text-sm font-semibold text-lav-deep" data-id="element-310" data-mp="2s28ba2y098s0">{eyebrow}</p>
          <h2 className="mt-3 font-display text-3xl font-semibold text-navy sm:text-5xl" data-id="element-311" data-mp="v9gb9qm8i8qq">{title}</h2>
          {subtitle && <p className="mx-auto mt-4 max-w-2xl text-sm text-navy-soft" data-id="element-312" data-mp="qall23lxthwl">{subtitle}</p>}
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-313" data-mp="h67xhyy0he7q">
          {testimonials.map((item, i) => <figure key={i} className="rounded-3xl bg-white p-5 shadow-card ring-1 ring-paper-dark" data-id="element-314" data-mp="m5b2xkhwlmg8" data-mpi={i}>
              <div className="flex items-center gap-2.5" data-id="element-315" data-mp="78jzn053zqlc">
                {item.source ? <>
                    <span className="flex h-11 w-11 items-center justify-center rounded-full bg-lav-soft" data-id="element-316" data-mp="c7myg2uhx0kv">
                      <QuoteIcon className="h-4 w-4 text-lav-deep" aria-hidden="true" data-id="element-317" data-mp="zwy1jqzbj726" />
                    </span>
                    <span className="rounded-full bg-paper px-2.5 py-1 text-[11px] font-semibold text-navy-soft" data-id="element-318" data-mp="14xlr087wffua">{item.source}</span>
                  </> : <>
                    {item.avatar && <img src={item.avatar} alt={item.author} width={44} height={44} loading="lazy" className="h-11 w-11 rounded-full object-cover ring-2 ring-paper-dark" data-id="element-319" data-mp="1ius7fw55h2gc" />}
                    <span className="flex gap-0.5" aria-label="Five out of five" data-id="element-320" data-mp="1xhqvri8pngqu">
                      {[0, 1, 2, 3, 4].map(s => <StarIcon key={s} className="h-3.5 w-3.5 fill-peach text-peach" aria-hidden="true" data-id="element-321" data-mp="1sk7hwjfxd5zf" />)}
                    </span>
                  </>}
              </div>
              <blockquote className="mt-3 text-[17px] italic leading-relaxed text-navy" data-id="element-322" data-mp="1jhy9q084pop7">“{item.quote}”</blockquote>
              <figcaption className="mt-4 text-xs text-navy-soft" data-id="element-323" data-mp="1el7vlifvx36f">
                <span className="block text-[13px] font-bold not-italic text-navy" data-id="element-324" data-mp="19rmuhhizvt30">{item.author}</span>
                {item.role}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}